export enum ValidationTokenErrorEnum {
  TOKEN_01 = 'TOKEN_01', //internal server error
  TOKEN_02 = 'TOKEN_02', //invalid token
  TOKEN_03 = 'TOKEN_03', // next token
  TOKEN_04 = 'TOKEN_04' // lock token
}
